<template>
    <div  class="chart">
        <div :id="refId || 'visualization'">
        </div>
    </div>
</template>
<script>
  import * as echarts from 'echarts';

export default {
    name: 'chart',
    props: [
        'refId',
        'chartAxisLabels',
        'sidebarVisible',
        'miniMode'
    ],
    data () {
        return {
            eChart: null,
            animate: true,
            resizeTimeout: null,
            exportChart: null,
            exportImageWidth: 1024,
            exportImageHeight: 768,
            chartId: null
        };
    },
    mounted () {
        // this.initChart();
    },
    methods: {
        initChart () {
            this.chartId = this.refId || 'visualization';

            this.buildChart(this.chartId);

            window.addEventListener('resize', () => {
                this.resizeChart();
            });
        },
        buildChart (id, isExport) {
            var chartDom = id ? document.getElementById(id) : document.getElementById(this.chartId),
                thisChart;

            if (isExport) {
                thisChart = echarts.init(chartDom);
            } else if (!this.eChart) {
                this.eChart = echarts.init(chartDom);
            }

            // this.setGraphData();
            if (this.$parent.setGraphAxisData) {
                this.$parent.setGraphAxisData();
            }

            this.$nextTick(() => {
                if (isExport) {
                    thisChart.setOption(this.$parent.chartOptions, true);
                } else {
                    this.eChart.setOption(this.$parent.chartOptions, true);
                }
            });

            return thisChart;
        },
        destroyChart () {
            if (this.eChart) {
                this.eChart.dispose();
            }
            this.eChart = null;
        },
        resizeChart () {
            if (this.animate) {
                this.eChart.setOption({
                    animation: false
                });
            }

            try {
                this.eChart.resize();
            } catch (er) {
                
            }

            if (this.resizeTimeout) {
                clearTimeout(this.resizeTimeout);
            }

            this.resizeTimeout = setTimeout(() => {
                this.animate = true;

                this.eChart.setOption({
                    animation: true
                });
            }, 300);
        },
        buildExportChart (file_name) {
            var exportDiv = document.createElement('div'),
                exportDivId = 'export-chart';

            exportDiv.setAttribute('id', exportDivId);
            exportDiv.style.width = this.exportImageWidth + 'px';
            exportDiv.style.height = this.exportImageHeight + 'px';
            exportDiv.style.position = 'fixed';
            exportDiv.style.top = '200%';
            exportDiv.style.opacity = '0';
            // exportDiv.style.position = 'absolute';
            // exportDiv.style.top = '0';
            // exportDiv.style.zIndex = '999999';
            // exportDiv.style.backgroundColor = '#fff';

            document.body.appendChild(exportDiv);

            this.exportChart = this.buildChart(exportDivId, true);
            this.exportChart.on('finished', () => {
                let legends = this.eChart.getOption().legend ? this.eChart.getOption().legend[0] : null
                if (legends) {
                    let key = Object.keys(legends.selected);
                    for (let i = 0; i < key.length; i++) {
                        if (!legends.selected[key[i]]) {
                            this.exportChart.dispatchAction({
                                type: 'legendToggleSelect',
                                name: key[i]
                            });
                        }
                    }
                }
                this.saveChartImage(file_name);               
            });
        },
        saveChartImage (file_name) {
            var dataURL,
                downloadButton;

            dataURL = this.exportChart.getDataURL({
                pixelRatio: 2,
                type: 'png',
                backgroundColor: '#fff'
            });

            if (isIE) {
                dataURL = this.exportChart.getDataURL();
                top.consoleRef = window.open('', 'Chart Download', 'width=1024, height=768, menubar=0, toolbar=1 , status=0, scrollbars=1, resizable=1');
                top.consoleRef.document.writeln('<html><head><title>Data</title></head><body bgcolor=white onLoad=\'self.focus()\'><p>Please right click on image and select <b>Save picture as...</b> to save.</p><img src=\'' + dataURL + '\'/></body></html>');
                top.consoleRef.document.close();
            } else {
                downloadButton = document.createElement('a');
                downloadButton.setAttribute('id', 'chart-export-button');
                downloadButton.setAttribute('download', 'Report ' + file_name + '.png');
                downloadButton.setAttribute('href', dataURL);
                downloadButton.style.opacity = '0';
                document.body.appendChild(downloadButton);

                downloadButton.click();
                downloadButton.remove();

            }

            this.$nextTick(() => {
                if (this.$parent.formatTimer) {
                    clearTimeout(this.$parent.formatTimer);

                    this.$parent.isFormattedExport = false;
                }

                this.exportChart.dispose();
                document.getElementById('export-chart').remove();
				
				gtag('event', 'Click', {
					'event_category': 'Export PNG',
					'event_label': 'Export Chart PNG',
					'value': 'Export Chart PNG'
				});	
            });
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '@/scss/variables.scss';
    .chart {
        margin-top: 0;
        width: 100%;
        // height: 300px;
        padding: 0 10px 10px 0;
        background-color: $white;
        position: relative;

        min-height: 200px;
        max-height: 500px;
        height: 40vh;

        overflow-x: hidden;
        overflow-y: auto;

        // #visualization {
        //     height: 300px;
        //     width: calc(100% - 60px);
        // }

        #visualization {
            height: 100%;
            // min-height: 200px;
            // max-height: 500px;
            // height: 40vh;

            // overflow-x: hidden;
            // overflow-y: auto;
        }
    }
    
    .legends {
        margin-bottom: 4px;
        padding: 0;
        list-style: none;
        .legend-bar {
            .circle {
                height: 1.2rem;
                width: 1.2rem;
                position: absolute;
                top: 2px;
                left: 4px;
            }
            .color-swatch {
            //     height: 1.2rem;
            //     width: 1.2rem;
            //     position: absolute;
            //     top: 2px;
            //     left: 4px;
            top: 3px;
            left: 5px;
            height: 15px;
            width: 15px;
            border-radius: 3px;
            }
            // }
        }
        li {
            display: inline-block;
            position: relative;
            font-size: 13px;
            .legend-item {
                display: inline-block;
                border: none;
                background-color: transparent;
                padding: 1px 4px 2px;
                span {
                    padding-left: 20px;
                    padding-right: 3px;
                }

                &.unselected {
                    color: #bbb;
                    svg {
                        fill: #999;
                    }
                    .color-swatch {
                        background-color: #999 !important;
                    }
                }
                &:hover, &:focus {
                    outline: none;
                    background-color: #eee;
                    border-radius: 5px;
                }
            }
            .circle {
                height: 1.2rem;
                width: 1.2rem;
                position: absolute;
                top: 2px;
                left: 4px;
            }
            .color-swatch {
                position: absolute;
                top: 3px;
                left: 5px;
                height: 16px;
                width: 16px;
                border-radius: 50%;
            }
        }
    }
</style>

